import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import toFa from '../../helpers/toFa';

const Pagination = ({
    className,
    total,
    perpage,
    visibleCount = 3,
    activePageProps = 0,
    onPageChange
}) => {
    const totalPages = Math.ceil(total / perpage);
    const [activePage, setActivePage] = useState(activePageProps);

    useEffect(() => {
        setActivePage(activePageProps);
    }, [total, perpage, visibleCount]);

    const clickHandler = page => {
        setActivePage(page);
        if (onPageChange) {
            onPageChange(page);
        }
    };

    const generatePage = item => {
        let pageNumber = item;
        let isActive = false;

        if (Array.isArray(item)) {
            const [activePageNumber] = item;
            pageNumber = activePageNumber;
            isActive = true;
        }
        return (
            <li key={pageNumber} className={isActive ? 'is-active' : ''}>
                <button type="button" onClick={() => clickHandler(pageNumber)}>
                    {toFa(`${pageNumber + 1}`)}
                </button>
            </li>
        );
    };

    const getPages = (currentPage, totalPages, visibleCount) => {
        const pagesArray = [];
        const siblingsCount = Math.floor(visibleCount / 2);
        const upperDiff = currentPage + siblingsCount;
        const lowerDiff = currentPage - siblingsCount;
        let upperRange;
        let lowerRange;

        if (lowerDiff <= 0) {
            lowerRange = Math.max(lowerDiff, 0);
            upperRange = upperDiff + Math.abs(lowerDiff);
        } else if (upperDiff <= totalPages) {
            lowerRange = Math.max(lowerDiff, 0);
            upperRange = upperDiff;
        } else {
            upperRange = totalPages;
            lowerRange = lowerDiff - (upperDiff - totalPages);
        }

        if (totalPages <= visibleCount - 1) {
            upperRange = totalPages;
            lowerRange = 0;
        }

        for (
            let loopIndex = lowerRange;
            loopIndex <= upperRange;
            loopIndex += 1
        ) {
            pagesArray.push(
                currentPage === loopIndex ? [loopIndex] : loopIndex
            );
        }

        return pagesArray;
    };

    return !perpage || !total || totalPages === 1 ? null : (
        <nav className={className}>
            <ul>
                <li className={activePage <= 0 ? 'is-hide' : ''}>
                    <button
                        type="button"
                        disabled={activePage <= 0}
                        onClick={() => clickHandler(activePage - 1)}
                    >
                        قبلی
                    </button>
                </li>
                {getPages(activePage, totalPages - 1, visibleCount).map(
                    generatePage
                )}
                <li className={activePage >= totalPages - 1 ? 'is-hide' : ''}>
                    <button
                        type="button"
                        onClick={() => clickHandler(activePage + 1)}
                        disabled={activePage >= totalPages - 1}
                    >
                        بعدی
                    </button>
                </li>
            </ul>
        </nav>
    );
};

Pagination.propTypes = {
    className: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired,
    perpage: PropTypes.number.isRequired,
    visibleCount: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired
};

export default styled(Pagination)`
    ul {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
    }

    li {
        button {
            background: #ffffff;
            border: none;
            padding: 6px 16px;
            margin: 0 16px;
            font-size: 12px;
            color: #13bdef;
            line-height: 21px;
            font-weight: bold;
            border-radius: 4px;
        }

        &:last-child,
        &:first-child {
            button {
                color: #000946;
                font-weight: 400;
            }
        }
    }
`;
